import { render } from "./legenda.vue?vue&type=template&id=25803d02"
import script from "./legenda.vue?vue&type=script&lang=js"
export * from "./legenda.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mrooze01/Pointer/projecten/knd/projects/2022/vet-scholen-wandelafstand/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__